module.exports = __webpack_public_path__ + "static/media/a3_03.9ca5c7ac.jpg";